import { StyledSubTitle, StyledText } from '@selfserve/react-ui';
import { getPlanListStatusIndicators } from '@selfserve/react-utils';
import { MouseEvent } from 'react';
import { useTranslation } from 'react-i18next';
import { AddOnItem } from '../data';
import {
  MenuButton,
  StyledInfoContainer,
  StyledItemContainer,
  StyledStatusContainer,
} from '../feature/plans-overview';

interface Props {
  addons: Array<AddOnItem>;
  addonPresentationInfo: Array<string>;
  open: boolean;
  selectedId: string;
  handleMenuClick: (
    isAddIn: boolean,
    name: string
  ) => (event: MouseEvent<HTMLButtonElement>) => void;
}

export const AddonsList = ({
  addons,
  addonPresentationInfo,
  open,
  selectedId,
  handleMenuClick,
}: Props) => {
  const { t } = useTranslation();
  return (
    <StyledInfoContainer className="addon-list">
      <StyledSubTitle as="span" className="sub-header">
        {t('common.your-addons')}
      </StyledSubTitle>
      {addons?.length ? (
        addons.map((addon, i) => {
          const { showStatus, isPending } = getPlanListStatusIndicators(
            addon.status
          );
          return (
            <StyledItemContainer key={addon?.id}>
              <div>
                <StyledText bold>{addon?.displayName}</StyledText>
                <StyledText as="span">{addonPresentationInfo[i]}</StyledText>
              </div>
              {showStatus && (
                <StyledStatusContainer status={addon.status as string}>
                  <span>{t(`subscription-status.${addon.status}`)}</span>
                  {isPending && <p>{t('common.on-hold-text')}</p>}
                </StyledStatusContainer>
              )}
              <MenuButton
                open={open && selectedId === addon.name}
                onClick={handleMenuClick(true, addon?.name as string)}
              />
            </StyledItemContainer>
          );
        })
      ) : (
        <StyledText className="no-addons">{t('common.no-addons')}</StyledText>
      )}
    </StyledInfoContainer>
  );
};
